import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  padding: 0 8px 10px 8px;
`;

export const AllStockButton = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  position: relative;
  border: 1px solid ${color.downgray};
  cursor: pointer;
  width: 100%;
  border-radius: 4px;

  .ant-checkbox {
    top: 0;
  }
`;
